import { Link } from "@inertiajs/react";
import { Box, Button, Center, Menu, IconButton, Image, Link as CLink, useBreakpointValue } from "@chakra-ui/react";
import { useAuth } from "../hooks/useAuth";
import { login_path, logout_path, top_path, my_dashboard_path, entry_my_one_on_one_games_path, events_path, my_settings_path } from "@/routes";
import logo_white from "@/assets/logo_white.svg";

interface HeaderProps {
  title?: string;
}

const Header = ({ title = "Open Court" }: HeaderProps) => {
  const { logged_in } = useAuth();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box as="header" bg="primary" color="white" className="mx-auto px-4 sm:px-6 lg:px-8 flex h-16 justify-between">
      <div className="flex gap-4">
        <div className="flex items-center">
          <div className="flex items-center gap-2">
            <Link href={top_path()} className="contents">
              <Image src={logo_white} alt={title} htmlWidth="80px" htmlHeight="50px" />
            </Link>
          </div>
        </div>
        <div className="flex">
          {logged_in && !isMobile && (
            <>
              <Box display="flex" gap={4} alignItems="center" fontSize={"sm"}>
                <CLink as={Link} href={my_dashboard_path()} color="white">
                  マイページ
                </CLink>
                <CLink as={Link} href={entry_my_one_on_one_games_path()} color="white">
                  1v1
                </CLink>
                <CLink as={Link} href={events_path()} color="white">
                  イベント
                </CLink>
              </Box>
            </>
          )}
        </div>
      </div>

      <Center>
        {logged_in ? (
          <div className="flex items-center gap-4">
            {!isMobile && (
              <Menu.Root>
                <Menu.Trigger asChild>
                  <IconButton variant="ghost" size="sm" aria-label="ユーザーメニュー">
                    ⛹️
                  </IconButton>
                </Menu.Trigger>
                <Menu.Positioner>
                  <Menu.Content>
                    <Menu.Item value="settings" asChild>
                      <Link href={my_settings_path()}>設定</Link>
                    </Menu.Item>
                    <Menu.Item value="logout" asChild>
                      <Link href={logout_path()} method="delete">
                        ログアウト
                      </Link>
                    </Menu.Item>
                  </Menu.Content>
                </Menu.Positioner>
              </Menu.Root>
            )}
          </div>
        ) : (
          <CLink asChild>
            <Link href={login_path()} className="contents">
              <Button variant="outline" color={{ base: "white", _hover: "primary" }}>
                ログイン
              </Button>
            </Link>
          </CLink>
        )}
      </Center>
    </Box>
  );
};

export default Header;
